import { createReducer } from '/@/store/utils';
import * as actions from './actions';

const initial = {
    user: undefined,
    zone: undefined,
    type: undefined,
    slug: undefined,
    metric: undefined,
    config: undefined,
    selectedEnvironmentRanges: undefined,
    selectedIds: [],
    modulesIds: [],
    extrasIds: [],
    featuresIds: [],
    metricsIds: [],
    completePreview: [],
};

export default createReducer(initial, {
    [actions.setUser]: (state, action) => {
        return { ...state, user: action.payload };
    },

    [actions.setProductDatasheetType]: (state, action) => {
        return { ...state, type: action.payload };
    },

    [actions.setProductDatasheetSlug]: (state, action) => {
        return { ...state, slug: action.payload };
    },

    [actions.setProductDatasheetConfig]: (state, action) => {
        return { ...state, config: action.payload };
    },

    [actions.setZone]: (state, action) => {
        return {
            ...state,
            zone: action.payload,
            metric: initial.metric,
            selectedIds: initial.selectedIds,
            selectedEnvironmentRanges: initial.selectedEnvironmentRanges,
            modulesIds: initial.modulesIds,
            extrasIds: initial.extrasIds,
            headToHeadByProduct: initial.headToHeadByProduct,
        };
    },

    [actions.setMetric]: (state, action) => {
        return { ...state, metric: action.payload };
    },

    [actions.setProfileEnvironment]: (state, action) => {
        return {
            ...state,
            selectedEnvironmentRanges: {
                ...state.selectedEnvironmentRanges,
                [action.payload.profileId]: action.payload.rangeId,
            },
        };
    },

    [actions.addProduct]: (state, action) => {
        return {
            ...state,
            selectedIds: [...state.selectedIds, action.payload],
        };
    },

    [actions.removeProduct]: (state, action) => {
        return {
            ...state,
            selectedIds: state.selectedIds.filter((id) => id !== action.payload),
        };
    },

    [actions.addModule]: (state, action) => {
        return {
            ...state,
            modulesIds: [...state.modulesIds, action.payload],
        };
    },

    [actions.removeModule]: (state, action) => {
        return {
            ...state,
            modulesIds: state.modulesIds.filter((id) => id !== action.payload),
        };
    },

    [actions.addExtra]: (state, action) => {
        return {
            ...state,
            extrasIds: [...state.extrasIds, action.payload],
        };
    },

    [actions.removeExtra]: (state, action) => {
        return {
            ...state,
            extrasIds: state.extrasIds.filter((id) => id !== action.payload),
        };
    },

    [actions.addFeature]: (state, action) => {
        return {
            ...state,
            featuresIds: [...state.featuresIds, action.payload],
        };
    },

    [actions.removeFeature]: (state, action) => {
        return {
            ...state,
            featuresIds: state.featuresIds.filter((id) => id !== action.payload),
        };
    },

    [actions.addMetric]: (state, action) => {
        return {
            ...state,
            metricsIds: [...state.metricsIds, action.payload],
        };
    },

    [actions.removeMetric]: (state, action) => {
        return {
            ...state,
            metricsIds: state.metricsIds.filter((id) => id !== action.payload),
        };
    },
    [actions.addProducttoPreview]: (state, action) => {
        return {
            ...state,
            completePreview: action.payload,
        };
    },
    [actions.setCompletePreview]: (state) => {
        return {
            ...state,
            completePreview: [],
        };
    },
});
